import FBConfig from "../FBConfig";
import { openDB } from 'idb';

const ReadFirebasePrints = async ({ PrintKotInvoice }) => {

    const indexedDB = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outlet_uuid = localStorage.getItem("outlet_uuid")
    if (!outlet_uuid) return console.log("no outlet uuid found in local storage");

    const collection_path = outlet_uuid + "/prints/"
    const ref = FBConfig.ref(FBConfig.db, collection_path);
    FBConfig.onChildAdded(ref, async data => {

        try {
            console.log("order received: ", data.key)
            const doc = await FBConfig.get(data.ref)
            if (doc.exists()) {

                console.log("order is still available on firebase\ndeleting order")
                console.log("order ref", data.ref);

                const kot = await data.val();
                console.log(kot)

                let tx = indexedDB.transaction("running_orders", "readonly").objectStore("running_orders");
                const order_json = await tx.get(data.key);

                tx = indexedDB.transaction("outlet", "readonly").objectStore("outlet");
                const outlet = await tx.get(outlet_uuid);

                tx = indexedDB.transaction("item_grouping", "readonly").objectStore("item_grouping");
                const item_groups = await tx.getAll();

                tx = indexedDB.transaction("item", "readonly").objectStore("item");
                const items = await tx.getAll();

                tx = indexedDB.transaction("seats", "readonly").objectStore("seats");
                const seat = order_json?.seat_uuid ? await tx.get(order_json?.seat_uuid) : '';

                tx = indexedDB.transaction("category", "readonly").objectStore("category");
                const categoryDetails = await tx.getAll();

                tx = indexedDB.transaction("user", "readonly").objectStore("user");
                const user = order_json?.payment_by_user_uuid ? await tx.get(order_json.payment_by_user_uuid) : '';

                tx = indexedDB.transaction("payment_modes", "readonly").objectStore("payment_modes");
                const paymentMode = await tx.getAll();

                PrintKotInvoice({
                    dependencies: {
                        user_title: user?.user_title,
                        order_json,
                        paymentMode,
                        categoryDetails,
                        kot_setup: outlet?.kot_setup,
                        kotNumber: +kot?.[0]?.kot,
                        section_name: outlet.section_details?.find(i => i.section_uuid === seat?.section_uuid)?.section_name,
                        seat_name: seat?.seat_name,
                        itemsDetails: items,
                    },
                    item_groups,
                    callback: async () => {
                        console.log('Completed; now deleting doc from firebase')
                        await FBConfig.remove(data.ref);
                        console.log("order is deleted from firebase", order_json?.order_uuid)
                    }
                })
            }
            else
                console.log("seat_uuid : ", data.val().seat_uuid, ", dinein order is deleted")
        }
        catch (error) {
            console.error(error);
        }
    });

    // FBConfig.onChildChanged(ref, (data) => {
    // });

    // FBConfig.onChildRemoved(ref, (data) => {
    // });
}

export default ReadFirebasePrints;